import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ReportParameterStation } from "@/types/report.type";
import { Pagination, paginationOptions } from "@/types/pagination.type";
import { ref, watch } from "vue";
import { i18n } from "@/plugins/i18n.plugin";

// - props

export default /*#__PURE__*/_defineComponent({
  props: {
    pagination: null
  },
  emits: ["changeSize", "changePage"],
  setup(__props: any, { emit }: { emit: ({
  (e: "changeSize", size: number): void;
  (e: "changePage", page: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pagination: Pagination<ReportParameterStation> | null;
}



const currentPage = ref(props.pagination?.currentPage || 1);

watch(
  () => props.pagination,
  (newVal) => {
    // - change currentPage
    currentPage.value = newVal?.currentPage || 1;
  }
);

// - emit


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function formatNumber(value: any) {
  if (!value || !Number(value) || value === "-") {
    return "-";
  } else {
    return i18n.global.n(Number(value), "fixed");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_table, {
      data: __props.pagination?.data || [],
      stripe: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "samplingPoint",
          label: _ctx.$t('label.samplingPoint'),
          width: "280"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "station",
          label: _ctx.$t('label.station'),
          width: "200",
          align: "center",
          "header-align": "center"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.station ? scope.row.station : "-"), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "magnitude",
          label: _ctx.$t('label.parameter'),
          width: "auto",
          align: "center",
          "header-align": "center"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.magnitude ? _ctx.$t(scope.row.magnitude) : "-"), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "dateTimeFormated",
          label: _ctx.$t('label.date'),
          width: "auto",
          align: "center",
          "header-align": "center"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "measurement",
          label: _ctx.$t('label.value'),
          align: "center",
          "header-align": "center"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(formatNumber(scope.row.measurement)), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      class: "app-table",
      layout: "total, sizes, prev, pager, next, jumper",
      currentPage: currentPage.value,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      "page-sizes": _unref(paginationOptions),
      "page-size": __props.pagination?.rowPerPage,
      total: __props.pagination?.totalRows,
      onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (emit('changeSize', $event))),
      onCurrentChange: _cache[2] || (_cache[2] = ($event: any) => (emit('changePage', $event)))
    }, null, 8, ["currentPage", "page-sizes", "page-size", "total"])
  ]))
}
}

})